import { Col, DatePicker, Form, FormInstance, Input, Row } from "antd";
import { DATE_FORMAT } from "../../../lib/constants";
import { useMemo } from "react";
import { Rule } from "antd/es/form";
import dayjs from "dayjs";
import { Footer } from "./Footer";
import { useExport } from "./hooks/useExport";

type FormItemsProps = {
  form: FormInstance;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  onChangeIsOpen: (value: boolean) => void;
};

export const FormItems = ({
  form,
  isLoading,
  setIsLoading,
  onChangeIsOpen,
}: FormItemsProps) => {
  const rules: Rule[] = useMemo(() => [{ required: true }], []);

  const descriptiveDateRules = useMemo(
    () => [
      { required: true },
      {
        max: 6,
        message: "Can't be more than 6 characters",
      },
    ],
    []
  );

  const initialValues = useMemo(
    () => ({
      batchDate: dayjs(),
    }),
    []
  );

  const { onExportClicked } = useExport(form, setIsLoading, onChangeIsOpen);

  return (
    <>
      <Form
        layout="vertical"
        requiredMark={false}
        className="pt-8 processing-print-form"
        initialValues={initialValues}
        form={form}
        disabled={isLoading}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              label="Batch Date"
              name="batchDate"
              className="mb-4"
              rules={rules}
            >
              <DatePicker
                format={DATE_FORMAT}
                className="w-100"
                placeholder="MM/DD/YY"
              />
            </Form.Item>

            <Form.Item
              label="Descriptive Date"
              name="descriptiveDate"
              className="mb-4"
              rules={descriptiveDateRules}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Effective Date"
              name="effectiveDate"
              className="mb-4"
              rules={rules}
            >
              <DatePicker
                format={DATE_FORMAT}
                className="w-100"
                placeholder="MM/DD/YY"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Footer
        onChangeIsOpen={onChangeIsOpen}
        isLoading={isLoading}
        onExport={onExportClicked}
      />
    </>
  );
};
